<template>
  <div>
    <h1
      v-if="isSent"
      class="password_title"
    >
      {{ $t('password.mail_send.title.send_email') }}
    </h1>
    <h1
      v-else
      class="password_title"
    >
      {{ $t('password.mail_send.title.password_reset') }}
    </h1>
    <template v-if="!isSent">
      <p class="password_description">
        {{ $t('password.mail_send.description_1') }}<br>{{
          $t('password.mail_send.description_2')
        }}<br>{{ $t('password.mail_send.description_3') }}<br>{{
          $t('password.mail_send.description_4')
        }}
      </p>
    </template>
    <div class="password_contents">
      <template v-if="isSent">
        <div class="password_contents_text_block">
          <p class="password_contents_text">
            <span class="password_contents_text_mail">{{ email }}</span>
            {{ $t('password.mail_send.contents_text_1') }}
          </p>
          <p class="password_contents_text">
            {{ $t('password.mail_send.contents_text_2') }}
          </p>
          <p class="password_contents_text">
            {{
              $t('password.mail_send.contents_text_3', {
                minutes: signatureExpirationMinutes,
              })
            }}
          </p>
        </div>
      </template>
      <template v-else>
        <div
          v-loading="isSubmit"
          class="password_form_block"
        >
          <div class="password_item">
            <p class="password_item_title">
              {{ $t('password.mail_send.email') }}
            </p>
            <input
              v-model="email"
              class="password_item_input"
              type="email"
              :class="{ is_error: isEmailError }"
            >
            <p
              v-for="(errorMessage, key) in emailErrorMessages"
              :key="key"
              class="password_item_error_text"
            >
              <span
                class="icon icon_exclamation icon_small password_item_error_text_icon"
              />{{ errorMessage }}
            </p>
          </div>
          <button
            type="button"
            class="password_btn button_orange"
            @click="submit"
          >
            {{ $t('common.send') }}
          </button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import PasswordApi from '../../api/PasswordApi';

export default {
  props: {
    signatureExpirationMinutes: {
      type: Number,
      required: true,
    },
  },
  setup() {
    const { t } = useI18n();
    const store = useStore();
    const isSent = ref(false);
    const isSubmit = ref(false);
    const email = ref('');
    const emailErrorMessages = ref([]);
    const isEmailError = computed(() => emailErrorMessages.value.length > 0);

    const submit = () => {
      isSubmit.value = true;
      PasswordApi.sendMail({
        email: email.value,
      })
        .then((returnValue) => {
          const { result, errorMessages } = returnValue;
          if (result) {
            isSent.value = true;
          } else {
            emailErrorMessages.value = errorMessages?.email || [];
          }
        })
        .catch(() => {
          store.dispatch('toast/openToast', {
            kind: 'error',
            text: t('password.mail_send.error'),
          });
        })
        .finally(() => {
          isSubmit.value = false;
        });
    };

    return {
      isSent,
      isSubmit,
      email,
      emailErrorMessages,
      isEmailError,
      submit,
    };
  },
};
</script>
